import { render, staticRenderFns } from "./SettingsNotificationSmsSecret.vue?vue&type=template&id=16c025c7&"
import script from "./SettingsNotificationSmsSecret.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationSmsSecret.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports